export const INVALID_EMAIL_ERROR = 'email_not_found'
export const INVALID_PASSWORD_ERROR = 'invalid_password'
